import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PuzzleSolutionWordDialogService {
  private solutionWords: BehaviorSubject<{
    solutionWord: string;
    solutionOriginal: string;
  }> = new BehaviorSubject<{
    solutionWord: string;
    solutionOriginal: string;
  }>(null);

  public solutionWords$: Observable<{
    solutionWord: string;
    solutionOriginal: string;
  }> = this.solutionWords.asObservable();

  private sayings: BehaviorSubject<{
    saying: string;
    sayingOriginal: string;
  }> = new BehaviorSubject<{ saying: string; sayingOriginal: string }>(null);

  public sayings$: Observable<{
    saying: string;
    sayingOriginal: string;
  }> = this.sayings.asObservable();

  public solutionDialogRegistered: EventEmitter<null> = new EventEmitter<null>();

  registerSolutionDialog() {
    this.solutionDialogRegistered.emit(null);
  }

  setSolutionWords(solutionWord: string, solutionOriginal: string) {
    this.solutionWords.next({ solutionWord, solutionOriginal });
  }

  setSayings(saying: string, sayingOriginal: string) {
    this.sayings.next({ saying, sayingOriginal });
  }
}
